document.addEventListener("DOMContentLoaded", function () {
  let r = document.querySelectorAll(".cc__categoriesserchtrigger");
  r.length > 0 &&
    r.forEach((e) => {
      let t = e.parentElement,
        i = t.querySelector(".cc__categoriessearchitems");
      window.matchMedia("(hover: none) and (pointer: coarse)").matches
        ? e.addEventListener("click", () => {
            i.toggleAttribute("open"), e.classList.toggle("isopentcatiitems");
          })
        : (t.addEventListener("mouseenter", () => {
            i.setAttribute("open", ""), e.classList.add("isopentcatiitems");
          }),
          t.addEventListener("mouseleave", () => {
            i.removeAttribute("open"), e.classList.remove("isopentcatiitems");
          }));
    });
  let c = document.querySelectorAll(".cc__producttab__listitem"),
    n = document.querySelectorAll(".cc__producttab__content");
  if (c.length > 0 && n.length > 0) {
    c.forEach((e) => {
      e.addEventListener("click", () => {
        let t = e.getAttribute("data-tab");
        c.forEach((e) => e.removeAttribute("open")),
          n.forEach((e) => e.removeAttribute("open")),
          e.setAttribute("open", ""),
          document.getElementById(t).setAttribute("open", "");
      });
    });
    let l = c[0],
      s = l.getAttribute("data-tab");
    l.setAttribute("open", ""),
      document.getElementById(s).setAttribute("open", "");
  }
  // Only handle accordion lists that haven't been initialized by the inline script
  document.querySelectorAll(".cc__productaccordion_list").forEach((list) => {
    if (list.hasAttribute("data-accordion-init")) return;

    let o = list.querySelectorAll(".cc__productaccordion_list_item");
    if (o.length > 0) {
      // Open the first visible accordion item
      let firstVisible = Array.from(o).find((el) => el.offsetParent !== null);
      if (firstVisible) firstVisible.setAttribute("open", "");

      o.forEach((e) => {
        e.addEventListener("click", (event) => {
          let t = event.currentTarget;
          // Close all other open accordions
          document.querySelectorAll(".cc__productaccordion_list_item[open]").forEach((item) => {
            if (item !== t) item.removeAttribute("open");
          });
          // Toggle current accordion
          if (t.hasAttribute("open")) {
            t.removeAttribute("open");
          } else {
            t.setAttribute("open", "");
            // Scroll newly opened accordion into view (with sticky header offset)
            setTimeout(() => {
              const header = document.querySelector('header') || document.querySelector('[data-section-type="header"]') || document.querySelector('.shopify-section-header');
              const headerOffset = header ? header.offsetHeight : 0;
              const elementPosition = t.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - headerOffset - 10;
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }, 100);
          }
        });
      });
    }
  });
  let a = (e) => {
      let t = e.dataset.swiper,
        i = e.querySelectorAll(".swiper-slide");
      if (i.length < 2) {
        let r = () => {
          if (window.innerWidth >= 768) {
            e.classList.add("swiper-disabled");
            let i = document.querySelector(`.swiper-button-next-${t}`),
              r = document.querySelector(`.swiper-button-prev-${t}`);
            i && (i.style.display = "none"), r && (r.style.display = "none");
          } else {
            e.classList.remove("swiper-disabled");
            let n = document.querySelector(`.swiper-button-next-${t}`),
              l = document.querySelector(`.swiper-button-prev-${t}`);
            n && (n.style.display = ""), l && (l.style.display = ""), c();
          }
        };
        window.addEventListener("resize", r), r();
        return;
      }
      function c() {
        new Swiper(`#${e.dataset.swiper}`, {
          slidesPerView: 1,
          spaceBetween: 12,
          autoHeight: !0,
          observer: !0,
          breakpoints: { 768: { slidesPerView: 2 }, 0: { slidesPerView: 1.2 } },
          navigation: {
            nextEl: `.swiper-button-next-${t}`,
            prevEl: `.swiper-button-prev-${t}`,
          },
        });
      }
      c();
    },
    p = document.querySelectorAll(".upsellswiper");
  p.length > 0 && p.forEach((e) => a(e));
  class d extends HTMLElement {
    constructor() {
      super(), (this.mainSwiper = null);
    }
    connectedCallback() {
      if (!this.querySelector(".cc-main-slider")) {
        console.error("ProductMediaGallery: Missing required elements.");
        return;
      }
      this.setupGallery(),
        setTimeout(() => {
          this.mainSwiper?.update();
        }, 50),
        window.addEventListener("resize", () => {
          this.mainSwiper?.update();
        });
    }
    setupGallery() {
      this.initMainSwiper();
    }
    initMainSwiper() {
      let e = this.querySelector(".cc-main-slider");
      this.mainSwiper = new Swiper(e, {
        loop: !1,
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: !0,
        observer: !0,
        observeParents: !0,
        navigation: {
          nextEl: ".cc-swiper-button-next",
          prevEl: ".cc-swiper-button-prev",
        },
        pagination: {
          el: ".cc-swiper-pagination",
          clickable: !0,
          renderBullet: function (e, t) {
            let i = this.slides[e],
              r = i ? i.dataset.image : "",
              c = i.classList.contains("video__thumb");
            return c
              ? '<span class="cc-flex-shrink-0 cc-flex cc-items-center cc-justify-center cc-size-[76px] !cc-mx-0 cc-rounded-none cc-bg-cover cc-bg-center cc-bg-no-repeat cc-opacity-100 ' +
                  t +
                  '" style="background-image: url(' +
                  r +
                  ');"><svg class="cc-size-[25px] cc-rounded-full" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none"><circle cx="12.5" cy="12.5" r="12.5" fill="#0C0C0C"/><path fill="#fff" d="m17 12-7 6V6l7 6Z"/></svg></span>'
              : '<span class="cc-flex-shrink-0 cc-size-[76px] !cc-mx-0 cc-rounded-none cc-bg-cover cc-bg-center cc-bg-no-repeat cc-opacity-100 ' +
                  t +
                  '" style="background-image: url(' +
                  r +
                  ');"></span>';
          },
        },
        on: {
          init: () => this.mainSwiper?.update(),
          slideChange: () => {
            this.handleSlideChange.bind(this),
              this.scrollActivePaginationBullet(this);
          },
        },
      });
    }
    handleSlideChange() {
      let e = this.querySelectorAll("video");
      if (
        (e.forEach((e) => {
          e.pause();
        }),
        !this.mainSwiper)
      )
        return;
      let t = this.mainSwiper.slides[this.mainSwiper.activeIndex],
        i = t ? t.querySelector("video") : null;
      i && i.play();
    }
    scrollActivePaginationBullet() {
      let e = this.querySelector(
        ".cc-swiper-pagination .swiper-pagination-bullet-active"
      );
      e &&
        e.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
    }
  }
  customElements.define("product-media-gallery", d),
    document
      .querySelectorAll(
        ".cc__productaccordioncontent li, .cc__producttab__content li"
      )
      .forEach((e) => {
        if (!e.querySelector("p")) {
          let t = e.innerHTML;
          e.innerHTML = `<p class="cc-w-[calc(100%-25px)]">${t}</p>`;
        }
      });

  // =========================
  // Sticky Add to Cart
  // =========================
  const stickyCart = document.querySelector('[data-sticky-cart]');

  if (stickyCart) {
    console.log('[Sticky Cart] Found sticky cart element');

    // Wait for Alpine.js to initialize if needed
    setTimeout(() => {
      // Observe product images section instead of product-info (which is sticky on desktop)
      const productImages = document.querySelector('.product-images');
      const mainForm = document.querySelector('[data-type="add-to-cart-form"]');

      console.log('[Sticky Cart] Product images element:', productImages);
      console.log('[Sticky Cart] Main form element:', mainForm);

      if (!productImages || !mainForm) {
        console.error('[Sticky Cart] Required elements not found. Product images:', productImages, 'Main form:', mainForm);
        return;
      }

      // Get main form elements
      const mainVariantInput = mainForm.querySelector('input[name="id"]');
      const mainQuantityInput = mainForm.querySelector('.js-input-quantity');
      const mainPriceInc = mainForm.querySelector('.js-product-price.js-inc-vat');
      const mainPriceEx = mainForm.querySelector('.js-product-price.js-ex-vat');

      // Get sticky cart elements
      const stickyQuantityInput = stickyCart.querySelector('[data-sticky-qty-input]');
      const stickyPriceInc = stickyCart.querySelector('[data-sticky-price-inc]');
      const stickyPriceEx = stickyCart.querySelector('[data-sticky-price-ex]');
      const stickyViewProductBtn = stickyCart.querySelector('[data-sticky-view-product]');

      // IntersectionObserver to show/hide sticky cart
      // Observes product images instead of product-info (which is sticky on desktop)
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Product images are visible - hide sticky cart
            console.log('[Sticky Cart] Product images in view - hiding sticky cart');
            stickyCart.style.display = 'none';
          } else {
            // Product images out of view - show sticky cart
            console.log('[Sticky Cart] Product images out of view - showing sticky cart');
            stickyCart.style.display = 'block';
          }
        });
      }, {
        threshold: 0.1,  // Trigger when 10% visibility changes
        rootMargin: '-100px 0px 0px 0px'  // Trigger 100px before leaving viewport
      });

      console.log('[Sticky Cart] Observing product images element');
      observer.observe(productImages);

      // Listen for variant/option changes in main form (supports Bold Options and native variants)
      // Update sticky cart price when variant selection changes
      if (mainVariantInput) {
        // Watch for changes to the main variant input (Bold Options updates this)
        const variantObserver = new MutationObserver(() => {
          updateStickyPrice();
        });

        variantObserver.observe(mainVariantInput, {
          attributes: true,
          attributeFilter: ['value']
        });

        // Also listen for any changes in the main form
        mainForm.addEventListener('change', () => {
          updateStickyPrice();
        });
      }

      // Sync quantity: Main form -> Sticky cart
      if (mainQuantityInput && stickyQuantityInput) {
        const quantityObserver = new MutationObserver(() => {
          if (stickyQuantityInput.value !== mainQuantityInput.value) {
            stickyQuantityInput.value = mainQuantityInput.value;
            stickyQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });

        quantityObserver.observe(mainQuantityInput, {
          attributes: true,
          attributeFilter: ['value']
        });

        mainQuantityInput.addEventListener('input', () => {
          stickyQuantityInput.value = mainQuantityInput.value;
          stickyQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        });

        // Sync quantity: Sticky cart -> Main form
        stickyQuantityInput.addEventListener('input', (e) => {
          mainQuantityInput.value = e.target.value;
          mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        });

        // Handle quantity buttons on sticky cart
        const minusBtn = stickyCart.querySelector('[data-sticky-qty-minus]');
        const plusBtn = stickyCart.querySelector('[data-sticky-qty-plus]');

        if (minusBtn) {
          minusBtn.addEventListener('click', () => {
            setTimeout(() => {
              mainQuantityInput.value = stickyQuantityInput.value;
              mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            }, 10);
          });
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', () => {
            setTimeout(() => {
              mainQuantityInput.value = stickyQuantityInput.value;
              mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            }, 10);
          });
        }
      }

      // Update sticky cart price based on selected variant
      function updateStickyPrice() {
        if (mainPriceInc && stickyPriceInc) {
          stickyPriceInc.textContent = mainPriceInc.textContent;
        }
        if (mainPriceEx && stickyPriceEx) {
          stickyPriceEx.textContent = mainPriceEx.textContent;
        }
      }

      // Listen for price changes in main form
      if (mainPriceInc) {
        const priceObserver = new MutationObserver(() => {
          updateStickyPrice();
        });

        priceObserver.observe(mainPriceInc, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }

      // Handle View Product button click - Scroll to product info
      if (stickyViewProductBtn) {
        stickyViewProductBtn.addEventListener('click', (e) => {
          e.preventDefault();
          console.log('[Sticky Cart] View product clicked');

          // Sync quantity values before scrolling
          if (stickyQuantityInput && mainQuantityInput) {
            console.log('[Sticky Cart] Syncing quantity:', stickyQuantityInput.value);
            mainQuantityInput.value = stickyQuantityInput.value;
            mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          }

          // Scroll to product images section (brings user to top of product)
          const productImagesSection = document.querySelector('.product-images');
          if (productImagesSection) {
            console.log('[Sticky Cart] Scrolling to product images');
            productImagesSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          } else {
            console.error('[Sticky Cart] Product images section not found');
          }
        });
      } else {
        console.error('[Sticky Cart] View product button not found');
      }

      // Initial price sync
      updateStickyPrice();
      console.log('[Sticky Cart] Initialization complete');
    }, 100);  // 100ms delay to ensure Alpine.js is ready
  }
});
